import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { SortFilter } from '@enums/sortFilter';
import { ClickOutSideDirective } from '@directives/click-out-side.directive';
import { LnChevronDownSvgIconComponent } from '@components/svg-icons/ln-chevron-down-svg-icon/ln-chevron-down-svg-icon.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-product-filter',
  imports: [ClickOutSideDirective, LnChevronDownSvgIconComponent, TranslocoPipe, NgClass],
  templateUrl: './ln-product-filter.component.html',
  styleUrl: './ln-product-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnProductFilterComponent {
  readonly TAG = 'LnProductFilterComponent';
  @Output() selectedFilterEvent = new EventEmitter<SortFilter>();
  @Input() selectedFilter = signal<SortFilter>(SortFilter.mayorPrecio);
  showMenu = signal(false);
  readonly filterValues = Object.values(SortFilter);

  ToggleMenu() {
    this.showMenu.set(!this.showMenu());
  }

  CloseMenu() {
    this.showMenu.set(false);
  }

  OnMenuItemSelect(option: SortFilter) {
    this.selectedFilter.set(option);
    this.ToggleMenu();
    this.selectedFilterEvent.emit(option);
  }
}
